<template>
<div id="ModelView" class="model-view">
  <bimface
      :show-error="tokenError"
      :view-token="viewToken"
      :file-id="fileId"
      from="FILE"
      file-type="FILE"
      height="100%"
      width="100%" />
</div>
</template>

<script>
import { mapMutations } from 'vuex'
import Config from '@/config'
import Bimface from '@/components/common/Bimface.vue'

export default {
  name: 'ModelView',
  components: { Bimface, },
  data() {
    return {
      viewToken: null,
      tokenError: false,
      spaceId: this.$route.params.spaceId,
      fileId: this.$route.params.fileId,
      fileVersionId: this.$route.query.fileVersionId,
    }
  },
  created() {
    try {
      // 获取viewToken
      if (this.fileVersionId) {
        // 获取文件版本信息
        this.$api.file.revisionInfo(this.spaceId, this.fileId, this.fileVersionId).then((data) => {
          this.setFileModelView(data)
        })
        // 获取viewToken
        this.$api.file.viewToken(this.spaceId, this.fileId, this.fileVersionId).then((data) => {
          this.viewToken = data || null
        }).catch(() => {
          this.tokenError = true
        })
      } else {
        this.tokenError = true
      }
    } catch (e) {
      this.tokenError = true
    }
  },
  mounted() {
    if (this.$route.name === 'FileModelView') {
      document.title = this.$route.query.title || Config.projectName
    }
  },
  methods: {
    ...mapMutations({
      setFileModelView: 'breadCrumbInfo/setFileModelView',
    })
  },
}
</script>

<style lang="less" scoped>
.model-view{
  height: calc(100vh - 40px);
}
</style>
